import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AboutSection } from './components/AboutSection';
import { Certifications } from './components/Certifications';
import { ServicesOverview } from './components/ServicesOverview';
import { ServiceDetails } from './components/ServiceDetails';
import { ProcessSteps } from './components/ProcessSteps';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { TaxPreparationPage } from './components/TaxPreparationPage';
import { ContactPage } from './components/ContactPage';
const HEADER_OFFSET = 80;
function HomePage() {
  const {
    hash
  } = useLocation();

  // When arriving from another page with a section link (e.g. /#faq),
  // scroll to that section once the page has rendered.
  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    const scrollToSection = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({
        top,
        behavior: 'auto'
      });
    };
    // Run now, then again after images/iframes settle so the position stays accurate
    const t1 = window.setTimeout(scrollToSection, 50);
    const t2 = window.setTimeout(scrollToSection, 600);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [hash]);
  return <div className="font-sans" data-id="element-0" data-mp="38kgk2adfzoog">
      <Header data-id="element-1" data-mp="3dkuvm2e95gr8" />
      <Hero data-id="element-2" data-mp="3dle3eqa6uorj" />
      <ServicesOverview data-id="element-3" data-mp="3dl4k1ljnffut" />
      <ServiceDetails data-id="element-4" data-mp="3dmfpdpsqsvo1" />
      <ProcessSteps data-id="element-5" data-mp="3dii3wxiozs0z" />
      <Testimonials data-id="element-6" data-mp="nvsub5qlapwh" />
      <AboutSection data-id="element-7" data-mp="nwc1brepbtvq" />
      <Certifications data-id="element-8" data-mp="nv0z3w0wmu6q" />
      <FAQ data-id="element-9" data-mp="nxn4pq48izmb" />
      <CTASection data-id="element-10" data-mp="nxx05t81tyze" />
      <Footer data-id="element-11" data-mp="su45pkwj98gt" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-12" data-mp="swq9d9gaz3tr">
      <Routes data-id="element-13" data-mp="36859fxwiety">
        <Route path="/" element={<HomePage data-id="element-15" data-mp="356sn718lka4" />} data-id="element-14" data-mp="35yngfn0fdzc" />
        <Route path="/tax-preparation" element={<TaxPreparationPage data-id="element-17" data-mp="3ud1en72ulk9k" />} data-id="element-16" data-mp="34nd1wz277z9" />
        <Route path="/contact" element={<ContactPage data-id="element-19" data-mp="3uevpttobhy0g" />} data-id="element-18" data-mp="3ubzsa6gdtbcj" />
      </Routes>
    </BrowserRouter>;
}